(() => {
  if (window.coOriginalReviewsLoaded) return;
  window.coOriginalReviewsLoaded = true;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const on = (el, type, fn) => el?.addEventListener(type, fn);
  function init(scope = document) {
    $$('[data-original-reviews]', scope).forEach(section => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      const entries = $$('[data-review-entry]', section);
      const list = $('.co-rv-list', section);
      const rating = $('[data-review-rating]', section);
      const sort = $('[data-review-sort]', section);
      const withPhotos = $('[data-review-with-photos]', section);
      const controls = $('[data-review-controls]', section);
      const count = $('[data-review-result-count]', section);
      const empty = $('[data-review-empty]', section);
      const pagination = $('[data-review-pagination]', section);
      const more = $('[data-review-more]', section);
      if (!list || !rating || !sort) return;
      const configuredPageSize = Number(section.dataset.reviewPageSize);
      const configuredMobilePageSize = Number(section.dataset.reviewPageSizeMobile);
      const desktopPageSize = Number.isInteger(configuredPageSize) && configuredPageSize > 0 ? configuredPageSize : 8;
      const mobilePageSize = Number.isInteger(configuredMobilePageSize) && configuredMobilePageSize > 0 ? configuredMobilePageSize : 7;
      const mobileReviews = matchMedia('(max-width: 749px)');
      let pageSize = mobileReviews.matches ? mobilePageSize : desktopPageSize;
      let limit = pageSize;
      const originalOrder = new Map(entries.map((entry, index) => [entry, index]));
      const score = entry => Number(entry.dataset.reviewRatingValue);
      function updateReviews() {
        const ordered = [...entries].sort((a, b) => {
          const difference = sort.value === 'highest' ? score(b) - score(a) : sort.value === 'lowest' ? score(a) - score(b) : sort.value === 'newest' ? (Date.parse(b.dataset.reviewDate) || 0) - (Date.parse(a.dataset.reviewDate) || 0) : 0;
          return difference || originalOrder.get(a) - originalOrder.get(b);
        });
        const matching = ordered.filter(entry => (rating.value === 'all' || score(entry) === Number(rating.value)) && (!withPhotos?.checked || entry.dataset.reviewHasPhoto === 'true'));
        const visible = new Set(matching.slice(0, limit));
        ordered.forEach(entry => { entry.hidden = !visible.has(entry); list.appendChild(entry); });
        if (count) count.textContent = `Showing ${visible.size} of ${matching.length} ${matching.length === 1 ? 'review' : 'reviews'}`;
        if (empty) empty.hidden = matching.length !== 0;
        if (pagination) pagination.hidden = matching.length <= limit;
        const nextCount = Math.min(pageSize, Math.max(0, matching.length - limit));
        if (more) more.textContent = `Show ${nextCount} more ${nextCount === 1 ? 'review' : 'reviews'}`;
      }
      const resetPage = () => { limit = pageSize; updateReviews(); };
      on(mobileReviews, 'change', () => { pageSize = mobileReviews.matches ? mobilePageSize : desktopPageSize; resetPage(); });
      on(rating, 'change', resetPage);
      on(withPhotos, 'change', resetPage);
      on(sort, 'change', resetPage);
      on($('[data-review-reset]', section), 'click', () => { rating.value = 'all'; if (withPhotos) withPhotos.checked = false; resetPage(); });
      on(more, 'click', () => {
        const previouslyVisible = new Set(entries.filter(entry => !entry.hidden));
        limit += pageSize;
        updateReviews();
        const firstNew = $$('[data-review-entry]', list).find(entry => !entry.hidden && !previouslyVisible.has(entry));
        firstNew?.focus({preventScroll: true});
      });
      const lightbox = $('[data-review-lightbox]', section);
      let photoTrigger;
      $$('[data-review-photo]', section).forEach(button => on(button, 'click', () => {
        if (!lightbox) return;
        const photo = $('[data-review-lightbox-image]', lightbox);
        photo.src = button.dataset.image; photo.alt = button.dataset.photoAlt || $('img', button)?.alt || 'Cocoony brush';
        const caption = $('[data-review-lightbox-caption]', lightbox);
        caption.textContent = button.dataset.photoAlt || '';
        caption.hidden = !caption.textContent;
        photoTrigger = button; lightbox.showModal();
      }));
      on($('[data-close-review-photo]', section), 'click', () => lightbox?.close());
      on(lightbox, 'click', event => { if (event.target !== lightbox) return; const box = lightbox.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) lightbox.close(); });
      on(lightbox, 'close', () => photoTrigger?.focus({preventScroll: true}));
      if (controls) controls.hidden = false;
      updateReviews();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
